var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(
			(_vm.$route.path === '/' || _vm.$route.path === '/login') &&
			(_vm.brand() === 'guild' || _vm.brand() === 'childcare') &&
			!_vm.isNewUrl()
		)?_c('div',{staticClass:"mt-3"},[_c('AlertInfo',{attrs:{"alert-title":"SuperConnector is no longer accessible from this website.","alert-message":_vm.message()}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }